import React, { useContext } from 'react';
import styles from './User.module.css';
import { AppContext } from '../../context/AppContextProvider';

const UserName = () => {
    const { userInfo } = useContext(AppContext);

    return <span className={styles.subTitle}>{userInfo?.fullName || ""}</span>;
};

export default UserName;
